import { addAftApi, getAllAftApi, getAllOrgsApi, getAllAftNamesApi } from "../../api/aft/aftApi";
import Types from "../types";
import { setGlobalLoader } from "./commonAction";

export const getAllAft = () => {
    return async function (dispatch) {
        dispatch(setGlobalLoader(true))
        const result = await getAllAftApi()
        dispatch({
            type: Types.ALL_AFT,
            payload: result
        });
        dispatch(setGlobalLoader(false))
    }
}

export const getAllAftNames = () => {
    return async function (dispatch) {
        const result = await getAllAftNamesApi()
        dispatch({
            type: Types.ALL_AFT_ACCOUNT_NAMES,
            payload: result?.accounts || []
        });
    }
}

export const addAft = (payload) => {
    return async function () {
        try {
            await addAftApi(payload)
        } catch (error) {
            console.warn(error)
        }
    }
}

export const getAllOrgs = (payload) => {
    return async function (dispatch) {
        try {
            const result = await getAllOrgsApi(payload)
            dispatch({
                type: Types.ORGANIZATIONAL_UNITS,
                payload: result?.orgUnits || []
            });
        } catch (error) {
            console.warn(error)
        }
    }
}